import React, { createContext, type ReactNode, useContext, useState } from 'react';

type PageTitleContextProps = {
  pageTitle: string;
  setPageTitle: (pageTitle: string) => void;
};

const PageTitleContext = createContext<PageTitleContextProps>(null);

type PageTitleProps = {
  children: ReactNode;
};

export function PageTitleProvider({ children }: PageTitleProps) {
  const [ pageTitle, setPageTitle ] = useState(null);

  return (
    <PageTitleContext.Provider value={{ pageTitle, setPageTitle }}>
      {children}
    </PageTitleContext.Provider>
  );
}

export function usePageTitle() {
  return useContext(PageTitleContext);
}
